//@ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import StageHeader from "components/StageHeader";
import PageStage from "components/stages/PageStage";

const CompanyBilling = ({ className }) => {
  const breadcrumb = [{ label: "Company", href: "/company" }, "Manage billing"];
  return (
    <PageStage>
      <StageHeader title="Manage billing" breadcrumb={breadcrumb} />
    </PageStage>
  );
};

CompanyBilling.defaultProps = {};

CompanyBilling.propTypes = {
  className: PropTypes.string,
};

export default CompanyBilling;
